/* Kindly line PDP (sections/kindly-line-pdp.liquid): gallery, option pickers -> variant, price + price a pair,
   sold-out states, size sheet, sticky mobile bar. Pure helpers are exported for v2/test/line.test.js. */
(function (root) {
  'use strict';

  /* Pairs in a pack: the number right before a word starting with "pair"/"pack", when 2 or more (else 0).
     Same rule as snippets/kindly-line-pairs.liquid. */
  function pairsIn(text) {
    var w = String(text || '').toLowerCase().replace(/[-\/,]/g, ' ').split(' ');
    for (var i = 0; i < w.length - 1; i++) {
      var nx = w[i + 1].slice(0, 4);
      if ((nx === 'pair' || nx === 'pack') && /^\d+$/.test(w[i]) && +w[i] > 1) return +w[i];
    }
    return 0;
  }
  function money(cents) { return '$' + (Math.round(cents) / 100).toFixed(2); }
  function findVariant(variants, opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) if (v.o[j] !== opts[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  /* What the buy box says for a picked variant. productSoldOut = no variant of the product is available. */
  function view(v, productTitle, productSoldOut) {
    var pairs = v ? (pairsIn(v.t) || pairsIn(productTitle)) : 0;
    var r = { price: v ? money(v.p) : '', per: '', disabled: true, label: '', sticky: '', stickyBtn: '' };
    if (v && pairs > 1) r.per = pairs + ' pairs · ' + money(v.p / pairs) + ' a pair';
    if (productSoldOut) { r.label = 'Sold out for now · Back soon'; r.sticky = r.label; r.stickyBtn = 'Email me'; return r; }
    if (!v) { r.label = 'This combination is not available'; r.sticky = r.label; r.stickyBtn = 'Pick options'; return r; }
    if (!v.a) { r.label = 'Sold out in this choice'; r.sticky = r.label; r.stickyBtn = 'Pick another'; return r; }
    r.disabled = false; r.label = 'Add to cart · ' + r.price; r.sticky = r.price; r.stickyBtn = 'Add to cart';
    return r;
  }

  function initGallery(rootEl) {
    var track = rootEl.querySelector('[data-kindly-gal-track]');
    if (!track) return null;
    var slides = track.children, idx = rootEl.querySelector('[data-kindly-gal-i]');
    var thumbs = rootEl.querySelectorAll('[data-kindly-gal-go]');
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (track.scrollTo) track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = current();
        if (idx) idx.textContent = i + 1;
        thumbs.forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
      }, 60);
    }, { passive: true });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-kindly-gal-go')); }); });
    var p = rootEl.querySelector('[data-kindly-gal-prev]'), n = rootEl.querySelector('[data-kindly-gal-next]');
    if (p) p.addEventListener('click', function () { go(current() - 1); });
    if (n) n.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
    });
    return { goToMedia: function (id) {
      for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === String(id)) { go(i); return; }
    } };
  }

  function init(rootEl) {
    var gal = initGallery(rootEl);
    var dataEl = rootEl.querySelector('[data-kl-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var title = rootEl.getAttribute('data-pairs-title') || '';
    var productSoldOut = rootEl.getAttribute('data-soldout') === '1';
    var groups = rootEl.querySelectorAll('[data-kl-opt]');
    var idInput = rootEl.querySelector('[data-kl-id]');
    var atc = rootEl.querySelector('[data-kl-atc]');
    var atcLabel = rootEl.querySelector('[data-kl-atc-label]');
    var priceEl = rootEl.querySelector('[data-kl-price]');
    var perEl = rootEl.querySelector('[data-kl-per]');
    var sticky = rootEl.querySelector('[data-kindly-sticky]');
    var stickyLabel = rootEl.querySelector('[data-kl-sticky-label]');
    var stickyBtn = rootEl.querySelector('[data-kl-sticky-btn]');
    var restock = rootEl.querySelector('[data-kindly-restock]');
    var form = rootEl.querySelector('form.kline__form') || (atc && atc.form);

    function picks() {
      return Array.prototype.map.call(groups, function (g) {
        var on = g.querySelector('[aria-checked="true"]');
        return on ? on.getAttribute('data-kl-val') : null;
      });
    }
    function markOut() {
      /* grey out values that have no available variant with the other current picks (only while the product has stock) */
      var cur = picks();
      Array.prototype.forEach.call(groups, function (g, gi) {
        g.querySelectorAll('[data-kl-val]').forEach(function (b) {
          var o = cur.slice(); o[gi] = b.getAttribute('data-kl-val');
          var v = findVariant(variants, o);
          var out = !productSoldOut && (!v || !v.a);
          b.classList.toggle('is-out', out);
        });
      });
    }
    function render() {
      var v = groups.length ? findVariant(variants, picks()) : variants[0];
      var r = view(v, title, productSoldOut);
      if (v && idInput) idInput.value = v.id;
      if (priceEl && r.price) priceEl.textContent = r.price;
      if (perEl) { perEl.textContent = r.per; perEl.hidden = !r.per; }
      if (atc) atc.disabled = r.disabled;
      if (atcLabel) atcLabel.textContent = r.label;
      if (stickyLabel) stickyLabel.textContent = r.sticky;
      if (stickyBtn) stickyBtn.textContent = r.stickyBtn;
      var cl = rootEl.querySelector('[data-kl-claim][data-claim-knee]');
      if (cl) {
        var styleG = rootEl.querySelector('[data-kl-name="style"] [aria-checked="true"]');
        var sv = styleG ? styleG.getAttribute('data-kl-val').toLowerCase() : '';
        cl.textContent = sv.indexOf('ankle') !== -1 ? cl.getAttribute('data-claim-ankle') : sv.indexOf('knee') !== -1 ? cl.getAttribute('data-claim-knee') : cl.textContent;
      }
      markOut();
      return v;
    }
    groups.forEach(function (g) {
      var cur = g.querySelector('[data-kl-cur]');
      g.querySelectorAll('[data-kl-val]').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('[data-kl-val]').forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
          if (cur) cur.textContent = b.getAttribute('data-kl-val');
          var v = render();
          if (v && v.m && gal) gal.goToMedia(v.m);
          if (v && window.history && history.replaceState) {
            try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) { /* ignore */ }
          }
        });
        b.addEventListener('keydown', function (e) {
          var list = Array.prototype.slice.call(g.querySelectorAll('[data-kl-val]')), i = list.indexOf(b);
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); list[(i + 1) % list.length].focus(); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); list[(i - 1 + list.length) % list.length].focus(); }
        });
      });
    });
    if (form) form.addEventListener('submit', function (e) { if (atc && atc.disabled) e.preventDefault(); });

    /* Size sheet */
    var sheet = rootEl.querySelector('[data-kindly-size-sheet]');
    function openSize() { if (sheet && sheet.showModal) sheet.showModal(); }
    rootEl.querySelectorAll('[data-kindly-open-size]').forEach(function (b) { b.addEventListener('click', openSize); });
    if (sheet) {
      var x = sheet.querySelector('[data-kindly-close-size]');
      if (x) x.addEventListener('click', function () { sheet.close(); });
      sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
    }

    /* Sticky bar: shows once the add-to-cart button has scrolled above the screen. */
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        });
      }).observe(atc);
    }
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (productSoldOut && restock) {
        restock.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var em = restock.querySelector('[data-kindly-restock-email]');
        if (em) em.focus({ preventScroll: true });
        return;
      }
      if (atc && !atc.disabled && form) { if (form.requestSubmit) form.requestSubmit(atc); else form.submit(); return; }
      var first = rootEl.querySelector('[data-kl-opt]') || atc;
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    render();
  }

  var API = { pairsIn: pairsIn, money: money, findVariant: findVariant, view: view, init: init };
  if (typeof module === 'object' && module.exports) { module.exports = API; return; }
  root.KindlyLine = API;
  function run() {
    document.querySelectorAll('[data-kindly-line]').forEach(function (el) {
      if (el.dataset.klReady) return;
      el.dataset.klReady = '1';
      init(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})(typeof window !== 'undefined' ? window : this);
